/**
 * Quick view gallery
 * ------------------------------------------------------------------------------
 * An quick view gallery file that contains scripts to function
 *
 * @namespace quickviewGallery
 */
import Carousel from './carousel';

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-quickview-gallery="container"]',
  containerNav: '[js-quickview-gallery="containerNav"]',
  featuredImage: '[js-quickview-gallery="featuredImage"]',
  featuredImageNav: '[js-quickview-gallery="featuredImageNav"]',
  featuredCarousel: '[js-quickview-gallery="featuredCarousel"]',
  featuredCarouselNav: '[js-quickview-gallery="featuredCarouselNav"]',
  featuredCarouselNavItem: '.product-gallery__featured-image-nav',
};

/**
 * Instance globals.
 */
let featuredCarousel = {};
let featuredCarouselNav = {};

/**
 * Initialise component.
 */
function init() {
  setDefaultState();
}

/**
 * Construct carousel objects on gallery images.
 */
function constructCarousels() {
  featuredCarousel = new Carousel(selectors.featuredCarousel, {
    cellSelector: selectors.featuredImage,
    prevNextButtons: true,
    pageDots: false,
  });

  featuredCarouselNav = new Carousel(selectors.featuredCarouselNav, {
    prevNextButtons: false,
    cellSelector: selectors.featuredImageNav,
    asNavFor: selectors.featuredCarousel,
    contain: true,
    pageDots: false,
    groupCells: true,
    wrapAround: false,
    cellAlign: 'center'
  });

  featuredCarousel.init();
  featuredCarouselNav.init();

  // $('.carouselNav').on( 'click', '.product-gallery__featured-image-nav',
  // function() {
  //   console.log('clicked');
  //   var index = $(this).index();
  //   featuredCarousel.flickity( 'select', index );
  // });

}

function constructCarouselNav() {

  // var navItems = [].slice.call(document.querySelectorAll(selectors.featuredCarouselNavItem));

  // if (navItems.length) {
  //     navItems.forEach((item, index) => {
  //         item.addEventListener('click', function () {
  //             featuredCarousel.selectCell(index);
  //         });
  //     });
  // }

  // featuredCarousel.on('change', function (index) {
  //     var activeItems = [].slice.call(document.querySelectorAll('.carousel-nav-selected'));
  //     if (activeItems.length) {
  //         activeItems.forEach(item => {
  //             item.classList.remove('carousel-nav-selected');
  //         })
  //     }
  //     navItems[index].classList.add('carousel-nav-selected');
  // });

  $('.carouselNav').on( 'click', '.product-gallery__featured-image-nav',
  function() {
    console.log('clicked');
    var index = $(this).index();
    featuredCarousel.flickity( 'select', index );
  });

  console.log('contructed Nav');
  // var buttonGroup = document.querySelector('div.carouselNav');
  // var buttons = buttonGroup.querySelectorAll('div.product-gallery__featured-image-nav');
  // buttons = fizzyUIUtils.makeArray( buttons );
  
  // buttonGroup.addEventListener( 'click', function( event ) {
  //   // filter for button clicks
  //   console.log('clicked');
  //   if ( !matchesSelector( event.target, 'div.product-gallery__featured-image-nav' ) ) {
  //     return;
  //   }
  //   var index = buttons.indexOf( event.target );
  //   featuredCarousel.selectCell( index );

  // });

}

/**
 * Set default state based on screen size.
 */
function setDefaultState() {
  constructCarousels();
  //constructCarouselNav();
}

/**
 * Export a new product gallery.
 */
export default () => {

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};

